import type { ColDef, ValueGetterParams } from 'ag-grid-community'

import { cn } from '@/lib/ui/style-helpers'

import { ControlCommentsCell } from '@/pages/control/ag-grid-control/components/cells/control-comments-cell'
import type { ControlRow } from '@/pages/control/ag-grid-control/types'

import { TABLE_COLUMN_WIDTHS } from '@/components/lemmala-design-system/table/consts'
import { numericComparator } from '@/components/lemmala-design-system/table/utils/comparators'
import { getDefaultColDef } from '@/components/lemmala-design-system/table/utils/grid-theme'

type GetCommentsColumnDefOptions = {
  // Tables grouped into scopes/categories disable sorting so group headers stay intact
  sortable?: boolean
}

// Base header class from the design-system default, extended to right-align the sort indicator
const defaultHeaderClass = getDefaultColDef<ControlRow>().headerClass as string

export const getCommentsColumnDef = ({
  sortable = true,
}: GetCommentsColumnDefOptions = {}): ColDef<ControlRow> => ({
  colId: 'comments',
  headerName: '',
  width: TABLE_COLUMN_WIDTHS.xs,
  headerClass: cn(defaultHeaderClass, 'flex items-center justify-end'),
  sortable,
  comparator: numericComparator,
  cellRenderer: ControlCommentsCell,
  cellClass: 'py-3',
  valueGetter: (params: ValueGetterParams<ControlRow>) =>
    params.data?.smartQuestion?.commentCount || 0,
  cellDataType: false,
})
